<template>
  <section class="relative overflow-hidden bg-[#f5f2ec] text-white md:min-h-[92vh] md:bg-[#1f2826]">
    <div class="relative aspect-[4/3] w-full overflow-hidden bg-[#1f2826] sm:aspect-[16/10] md:absolute md:inset-0 md:aspect-auto">
      <Carousel :images="imageList" />
      <div class="pointer-events-none absolute inset-0 z-10 bg-gradient-to-t from-black/20 via-transparent to-black/10 md:from-black/45 md:to-black/15"></div>
      <div class="pointer-events-none hidden md:block absolute inset-x-0 bottom-0 z-10 h-44 bg-gradient-to-t from-[#f5f2ec]/75 via-[#f5f2ec]/15 to-transparent"></div>
    </div>

    <h1 class="sr-only">PHOSPHENE ARCHITECTS</h1>
    <div class="relative z-10 px-4 pb-6 pt-3 sm:px-6 md:pointer-events-none md:absolute md:inset-0 md:mx-auto md:max-w-7xl md:bg-transparent md:px-8 md:pb-0 md:pt-0 lg:px-10">
      <aside class="border-l border-[#9b8f78] bg-[#1f2826] px-4 py-3 shadow-[0_14px_35px_rgba(31,40,38,0.12)] md:absolute md:bottom-24 md:left-auto md:right-8 md:w-[34rem] md:border-white/40 md:bg-black/20 md:py-4 md:shadow-none md:backdrop-blur-[2px] lg:right-10">
        <Transition name="hero-quote" mode="out-in">
          <p
            :key="statementIndex"
            class="font-serif text-sm leading-6 text-white/95 sm:text-base sm:leading-7 md:text-xl md:leading-8"
          >
            <span aria-hidden="true">&ldquo;</span>{{ currentStatement }}<span aria-hidden="true">&rdquo;</span>
          </p>
        </Transition>
      </aside>
    </div>
  </section>
</template>

<script>
import Carousel from "./Carousel.vue";
import { computed, onMounted, onUnmounted, ref } from "vue";
import { useStorageFolder } from "@/composables/useStorageAssets";
import { storageFolders } from "@/config/storageSections";

const designStatements = [
  "A poorly planned home can never be corrected cheaply later.",
  "We design homes around your daily life, not just around square feet.",
  "We help clients spend where it matters and avoid spending where it doesn't.",
  "Construction lasts years. Design decisions last generations.",
  "Many expensive site mistakes happen because nobody is coordinating the bigger picture.",
  "We reduce confusion before money is spent on site.",
  "We balance aesthetics, practicality, budget, climate response, and execution reality together.",
  "We are involved in ensuring the design intent and execution quality remain aligned throughout the project.",
  "Our team is going to protect your investment better than anyone else.",
  "We ensure every aspect of the project works together from day one.",
  "We don't design generic houses. We design specifically for your land, climate, lifestyle, and long-term comfort.",
  "A building can be constructed by anyone. But creating a cohesive living experience requires coordinated design thinking.",
  "Our role is not to increase construction cost. Our role is to ensure the money you already plan to invest is utilized intelligently.",
  "Anyone can construct a building. But not every building becomes a well-designed home.",
];

export default {
  components: { Carousel },
  setup() {
    const { assets: imageList } = useStorageFolder(storageFolders.homeCarousel);
    const statementIndex = ref(0);
    let statementTimer;

    const currentStatement = computed(
      () => designStatements[statementIndex.value]
    );

    onMounted(() => {
      statementTimer = window.setInterval(() => {
        statementIndex.value =
          (statementIndex.value + 1) % designStatements.length;
      }, 5200);
    });

    onUnmounted(() => {
      window.clearInterval(statementTimer);
    });

    return { imageList, statementIndex, currentStatement };
  },
};
</script>

<style lang="scss" scoped>
.hero-quote-enter-active,
.hero-quote-leave-active {
  transition: opacity 0.45s ease, transform 0.45s ease;
}

.hero-quote-enter-from,
.hero-quote-leave-to {
  opacity: 0;
  transform: translateY(8px);
}
</style>
